import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import Fade from '@material-ui/core/Fade';
import FormHelperText from '@material-ui/core/FormHelperText';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import ErrorIcon from 'react-feather/dist/icons/alert-circle';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    error: {
      marginTop: 0,
      width: '100%',
      whiteSpace: 'pre-wrap',
      '&:empty': {
        minHeight: 0,
        padding: 0,
      },
    },
    errorPaper: {
      zIndex: theme.zIndex.modal,
      color: theme.palette.red[500],
      background: theme.palette.red[100],
      borderRadius: theme.spacing(0.5),
      display: 'flex',
      alignItems: 'center',
      fontFamily: `'Ubuntu Mono', monospace`,
      fontSize: 16,
      lineHeight: 1.2,
      overflow: 'hidden',
      padding: theme.spacing(2, 4.5, 2, 0),
      position: 'relative',
      '&:before': {
        background: theme.palette.red[500],
        display: 'block',
        content: `''`,
        borderRadius: 3,
        height: '85%',
        left: -3,
        position: 'absolute',
        width: 6,
      },
    },
    errorIcon: {
      alignSelf: 'flex-start',
      margin: theme.spacing(-0.25, 1, 0, 2),
      height: 22,
      width: 22,
    },
  })
);

interface Props {
  className?: string;
  error: string;
}

const CodeError = ({ className, error }: Props) => {
  const classes = useStyles();

  return (
    <Fade in={true}>
      <FormHelperText
        id="helper-text"
        className={classes.error}
        component={'pre' as any}
      >
        <Paper className={clsx(classes.errorPaper, className)}>
          <ErrorIcon className={classes.errorIcon} />
          <div>{error}</div>
        </Paper>
      </FormHelperText>
    </Fade>
  );
};

export default CodeError;
